import React, { useEffect, useRef, useState } from "react";
import "./HeroSection.css";
import scooter from "../../../Image/scootys image/novo-x/novax-orange7.png"; // use your image
import PopupTestDrive from "../PopupTestDrive/PopupTestDrive";
import { useNavigate } from "react-router-dom";

const HeroSlider = () => {
  const navigate = useNavigate();

  const sectionRef = useRef(null);
  const [animate, setAnimate] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimate(true);
          observer.disconnect(); // run once
        }
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className={`hero ${animate ? "show" : ""}`}>
      {/* Left Arrow */}
      <button className="arrow left">‹</button>

      {/* Left Side */}
      <div className="hero-left">
        <img src={scooter} alt="Scooter" className="Hero_scooter " />

        <div className="price-box">
          <strong>₹ 39,999</strong>
          <span>Starting Price</span>
        </div>
      </div>

      {/* Right Side */}
      <div className="hero-right">
        <h1>
          More Than a Ride <br />
          <span>It's a Statement</span>
        </h1>

        <p>
          Make an impression with our sleek, urban design that doesn’t
          compromise on performance or efficiency.
        </p>

        <div className="cta">
          <button
            className="hero_primary"
            onClick={() =>
              navigate("/explore", {
                state: { id: 3 }, // ✅ NOVA-x
              })
            }
          >
            View Details
          </button>
          <button className="secondary" onClick={() => setShowPopup(true)}>
            Test Ride
          </button>
        </div>

        <div className="Herofeatures">
          <div>
            <span>⚡</span>
            <strong>4 Hours</strong>
            <small>Charging</small>
          </div>
          <div>
            <span>🔋</span>
            <strong>Lithium</strong>
            <small>Battery</small>
          </div>
          <div>
            <span>🛣️</span>
            <strong>UpTo 130 km</strong>
            <small>Range</small>
          </div>
          <div>
            <span>⏱️</span>
            <strong>25 km/h</strong>
            <small>Low Speed</small>
          </div>
        </div>
      </div>

      {/* Right Arrow */}
      <button className="arrow right">›</button>
      {showPopup && <PopupTestDrive onClose={() => setShowPopup(false)} />}
    </section>
  );
};

export default HeroSlider;
